import commonDaily from './help/helpContentCommonDaily.json'
import commonRequests from './help/helpContentCommonRequests.json'
import commonMasters from './help/helpContentCommonMasters.json'
import managementReports from './help/helpContentManagementReports.json'
import managementMaster from './help/helpContentManagementMaster.json'
import admin from './help/helpContentAdmin.json'

export default [
  ...commonDaily,
  ...commonRequests,
  ...commonMasters,
  ...managementReports,
  ...managementMaster,
  ...admin
]
